const FOCUSABLE = [
  'a[href]',
  'area[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'iframe',
  '[contenteditable="true"]',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

/** Tabbable descendants in DOM order (skips hidden and inert content). */
export function focusableIn(root: HTMLElement): HTMLElement[] {
  return [...root.querySelectorAll<HTMLElement>(FOCUSABLE)].filter(
    (el) =>
      !el.closest('[inert]') &&
      !el.hasAttribute('hidden') &&
      el.getAttribute('aria-hidden') !== 'true',
  );
}

/** Focus the first invalid control of a form (after a failed submit — WCAG 3.3.1). */
export function focusFirstInvalid(form: HTMLElement | null): boolean {
  const el = form?.querySelector<HTMLElement>('[aria-invalid="true"]');
  el?.focus();
  return Boolean(el);
}
